import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, intlShape } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { toggleHowItWorks } from 'actions/ui'
import AppRoutes from 'components/routes/AppRoutes'
import MainNav from 'components/MainNav'
import LocaleSwitcher from 'components/LocaleSwitcher'
import HowItWorks from 'components/HowItWorks'

const getCurrentPage = () => {
  const path = window.location.pathname

  if (path.includes('reservation')) {
    return 'reservation'
  } else if (path.includes('event')) {
    return 'event'
  } else if (path.includes('gift-card')) {
    return 'gift-card'
  }
  return 'home'
}

export class App extends React.Component {
  render() {
    const {
      currentLocale,
      toggleHowItWorksOpened, howItWorksOpened,
      match,
      intl,
      cellars,
    } = this.props
    const { formatMessage } = intl
    const { cellarId } = match.params

    let ocmEnabled = false
    if (cellarId && cellars[cellarId]) {
      const keys = Object.keys(cellars[cellarId])
      ocmEnabled = cellars[cellarId][keys[0]].ocmEnabled
    }

    const classes = ['app', `lang--${currentLocale}`, `page--${getCurrentPage()}`]
    if (window.__showLocation) {
      classes.push(`location--${window.__showLocation}`)
    }
    if (window.__iframe) {
      classes.push('iframe-embed')
    }

    return (
      <div className={classes.join(' ')}>
        <header>
          <div className="header">
            <div className="grid--middle grid--full" style={{ position: 'relative' }}>
              <div className="grid__item width-8-12">
                <img className="header__logo" src="/images/logo.png" alt="Bookingsoft" />
                <MainNav
                  toggleHowItWorksOpened={toggleHowItWorksOpened}
                />
              </div>
              <div className="grid__item width-4-12">
                <div style={{ float: 'right' }}>
                  <LocaleSwitcher
                    currentLocale={currentLocale}
                    cellarId={match.params.cellarId}
                  />
                </div>
              </div>
            </div>
          </div>
        </header>
        <hr id="app__hr" />
        <HowItWorks
          opened={howItWorksOpened}
          toggle={toggleHowItWorksOpened}
        />
        <div>
          <AppRoutes />
        </div>
        <footer className="footer">
          <img className="footer__logo" src="/images/logo-footer.png" alt="Bookingsoft" />
          {
            !ocmEnabled ? '' :
              (
                <div className="footer__ocm--holder">
                  <img className="footer__ocm--flag" src="/images/ue-flag.jpg"></img>
                  <span className="align--left">
                  CAMPAGNA FINANZIATA AI SENSI DEL REG. UE. N. 1308/2013<br />
                  CAMPAIGN FINANCED ACCORDING TO EU REG. N. 1308/2013
                  </span>
                </div>
              )
          }
          <p>WINEAROUND SRL ALL RIGHTS RESERVED</p>
          <p>Corso Libertà 53, Canelli 14053 (AT) - Italia</p>
          <p>PARTITA IVA 01494960055</p>
          <a href={formatMessage({ id: 'app.root.site_url' })}
            target="_blank" rel="noreferrer"
          >
            powered by Bookingsoft
          </a>
          <a href={formatMessage({ id: 'app.root.privacy-policy-url' })}
            className="footer__link iubenda-nostyle no-brand iubenda-embed"
            title="Privacy Policy"
            target="_blank" rel="noreferrer"
          >
            Privacy Policy
          </a>
          <a href={formatMessage({ id: 'app.root.terms-and-conditions-url' })}
            className="footer__link iubenda-nostyle no-brand iubenda-embed"
            title="Privacy Policy"
            target="_blank" rel="noreferrer"
          >
            Terms and conditions
          </a>
        </footer>
      </div>
    )
  }
}

App.propTypes = {
  cellars: PropTypes.object.isRequired,
  currentLocale: PropTypes.string.isRequired,
  howItWorksOpened: PropTypes.bool.isRequired,
  toggleHowItWorksOpened: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
}

function mapStateToProps(state) {
  return {
    cellars: state.cellars,
    currentLocale: state.ui.locale,
    howItWorksOpened: state.ui.howItWorksOpened,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleHowItWorksOpened: toggleHowItWorks,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(App))
